// extracted by mini-css-extract-plugin
module.exports = {"check":"Check_check_2Z70u","checked":"Check_checked_2h_fJ"};